import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import {
	FieldShell,
	fieldClassName,
	fieldErrorClassName,
	fieldId,
} from "@/components/ui/field";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
	label?: string;
	error?: string;
}

// Native <select> styled like the other fields.
const Select = forwardRef<HTMLSelectElement, SelectProps>(
	({ className, label, error, id, ...props }, ref) => {
		const selectId = fieldId(id, label);

		return (
			<FieldShell id={selectId} label={label} error={error}>
				<select
					id={selectId}
					className={cn(
						fieldClassName,
						"h-9 py-0",
						error && fieldErrorClassName,
						className,
					)}
					ref={ref}
					{...props}
				/>
			</FieldShell>
		);
	},
);

Select.displayName = "Select";

export { Select };
